// @ts-strict-ignore
import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {InputSize} from 'common/components/input/types';
import {IronContextRegistry} from 'common/report/context-registry';

import {CopyToClipboardState} from './types';
import css from './index.inline.styl';
import {template} from './template';

type CopyToClipboardJSXProps = {
  attrs: {
    value: string;
    label: string;
    'icon-only'?: boolean;
    size?: InputSize;
    'full-width'?: boolean;
  };
};

export class CopyToClipboard extends Component<CopyToClipboardState, TODO, null, null, IronContextRegistry> {
  static get attrsSchema(): AttrsSchema<TODO> {
    return {
      ...super.attrsSchema,
      value: {
        description: `The value to be copied`,
        type: `string`,
      },
      label: {
        description: `The label to be displayed on top of the input`,
        type: `string`,
        default: ``,
      },
      'icon-only': {
        description: `Copy button only shows copy icon when true`,
        type: `boolean`,
      },
      size: {
        description: `Size of the input text and icon`,
        type: `string`,
        default: InputSize.Large,
      },
      'full-width': {
        description: `Forces the input to take up full width`,
        type: `boolean`,
      },
    };
  }

  get i18n() {
    return this.getContext(`i18n`);
  }

  get t() {
    return this.i18n.t;
  }

  get print() {
    return this.i18n.print;
  }

  get config() {
    return {
      useShadowDom: true,
      template,
      css,
      contexts: [`i18n` as const],
      defaultState: {
        copyElement: null,
        isCopied: false,
      },
      helpers: {
        handleInsert: (copyEl: HTMLInputElement) => {
          this.update({copyElement: copyEl});
        },
      },
    };
  }
}

export const CopyToClipboardEl = defineAndMakeJsxFactory(`mp-copy-to-clipboard`, CopyToClipboard);
export const CopyToClipboardReact = panel2react<CopyToClipboardJSXProps>(`mp-copy-to-clipboard`, CopyToClipboard);
